module.exports = __webpack_public_path__ + "static/media/WARNING_YELLOW.cec5151f.svg";